import script from "./PwaStatusBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PwaStatusBanner.vue?vue&type=script&setup=true&lang=js"

import "./PwaStatusBanner.vue?vue&type=style&index=0&id=c7f6da5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7f6da5e"]])

export default __exports__